/// <amd-module name="VSS/Platform/Components/Format" />
export * from "./Format/Format";
export { FormatComponentProps } from "./Format/Format.Props";
